import { MenuItem } from '../types/menu-item.type';

export const menuItems: MenuItem[] = [
  { id: 'upcoming_events', key: 'menu_item.events', routerLink: '/events' },
  { id: 'about_us', key: 'menu_item.about_us', routerLink: '/about' },
  { id: 'booking', key: 'menu_item.booking', routerLink: '/booking' },
  { id: 'gallery', key: 'menu_item.gallery', routerLink: '/gallery' },
  { id: 'membership_program', key: 'menu_item.membership_programs', routerLink: '/membership-program' },
  { id: 'shop', key: 'menu_item.shop', link: 'https://shop.klubovnasl.sk' },
  { id: 'contact', key: 'contact', scrollToBottom: true },
  { id: 'support', key: 'menu_item.donio', routerLink: '/support', onlyFooter: true },
  { id: 'login', key: 'menu_item.login', routerLink: '/login', onlyFooter: true, consoleApp: true },
];

export const menuItemsMobile: MenuItem[] = [
  { id: 'home', key: 'home', routerLink: '/home' },
  { id: 'upcoming_events', key: 'menu_item.events', routerLink: '/events' },
  { id: 'about_us', key: 'menu_item.about_us', routerLink: '/about' },
  { id: 'booking', key: 'menu_item.booking', routerLink: '/booking' },
  { id: 'gallery', key: 'menu_item.gallery', routerLink: '/gallery' },
  { id: 'membership_program', key: 'menu_item.membership_programs', routerLink: '/membership-program' },
  { id: 'shop', key: 'menu_item.shop', link: 'https://shop.klubovnasl.sk' },
  { id: 'contact', key: 'contact', scrollToBottom: true },
];
